import Flex from 'antd/es/flex';
import Card from 'antd/es/card/Card';
import Title from 'antd/es/typography/Title';
import { FC, useEffect } from 'react';
import Text from 'antd/es/typography/Text';
import { useGetTenderVendorContactsMutation } from '@Features/MaterialRequest/requests/TenderRequest/store/api/TenderRequestApiSlice';
import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';
import styles from './VendorDetails.module.css';

interface VendorDetailsProps {
  vendorId: number;
}

const VendorDetails: FC<VendorDetailsProps> = ({ vendorId }) => {
  const [getVendorContacts, { data }] = useGetTenderVendorContactsMutation();

  useEffect(() => {
    getVendorContacts(String(vendorId));
  }, [getVendorContacts, vendorId]);

  if (!data) return null;

  return (
    <Flex vertical gap="16px">
      {data
        .filter((vendorContact) => vendorContact.occupation)
        .map(({ name, email, occupation, phone }) => {
          return (
            <Card className={styles.card}>
              <Title level={5} className={styles.cardTitle}>
                {name}
              </Title>
              <Flex gap="4px 0" vertical>
                <Flex justify="space-between">
                  <Text>Occupation</Text>
                  <Text>{occupation || EMPTY_FIELD_PLACEHOLDER}</Text>
                </Flex>
                <Flex justify="space-between">
                  <Text>Email</Text>
                  <Text>{email || EMPTY_FIELD_PLACEHOLDER}</Text>
                </Flex>
                <Flex justify="space-between">
                  <Text>Phone Number</Text>
                  <Text>{phone || EMPTY_FIELD_PLACEHOLDER}</Text>
                </Flex>
              </Flex>
            </Card>
          );
        })}
    </Flex>
  );
};

export default VendorDetails;
